export enum ChapterStatus{
	WORKING = 'WORKING',
	TERMINATED = 'TERMINATED',
	NOT_STARTED = 'NOT_STARTED',
}
